import React from "react";

import { AirlinesDataProvider } from "../../common/data/lookup-data-providers/AirlinesDataProvider";
import { DistributorsDataProvider } from "../../common/data/lookup-data-providers/DistributorsDataProvider";
import { VersionTypesDataProvider } from "../../common/data/lookup-data-providers/VersionTypesDataProvider";

type AssetsLookupDataProvidersProps = React.PropsWithChildren<unknown>;

export const AssetsLookupDataProviders: React.FunctionComponent<AssetsLookupDataProvidersProps> = ({
    children
}: AssetsLookupDataProvidersProps) => {
    return (
        <AirlinesDataProvider>
            <VersionTypesDataProvider>
                <DistributorsDataProvider>{children}</DistributorsDataProvider>
            </VersionTypesDataProvider>
        </AirlinesDataProvider>
    );
};
